import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./components/Login/Login";
import { SessionProvider } from "./components/Login/SessionContext";
import AuthGuard from "./components/Login/AuthGuard";

import Layout from "./components/Layout/Layout";
import Bbs from "./components/Bbs/Bbs";
import BbsView from "./components/Bbs/BbsView";
import BbsWrite from "./components/Bbs/BbsWrite";
import BbsEdit from "./components/Bbs/BbsEdit";
import BbsMain from "./components/Bbs/BbsMain";
import Tag from "./components/Bbs/Tag";
import AdminDashboard from "./components/Admin/AdminDashboard";
import Profile from "./components/Profile/Profile";
import SearchResults from "./components/Bbs/SearchResults";

function App() {
  return (
    <SessionProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={<Layout />}>
            <Route index element={<BbsMain />} />
            <Route path="/bbs/:moduleName" element={<Bbs />} />
            <Route path="/bbs/:moduleName/:document_id" element={<BbsView />} />
            <Route path="/tag" element={<Tag />} />
            <Route path="/search" element={<SearchResults />} />
            <Route
              path="/profile"
              element={
                <AuthGuard>
                  <Profile />
                </AuthGuard>
              }
            />
            <Route
              path="/bbs/write/:moduleName"
              element={
                <AuthGuard>
                  <BbsWrite />
                </AuthGuard>
              }
            />
            <Route
              path="/bbs/:moduleName/edit/:document_id"
              element={
                <AuthGuard>
                  <BbsEdit />
                </AuthGuard>
              }
            />
            <Route
              path="/admin"
              element={
                <AuthGuard>
                  <AdminDashboard />
                </AuthGuard>
              }
            />
          </Route>
        </Routes>
      </Router>
    </SessionProvider>
  );
}

export default App;
